"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/babel-runtime/helpers/classCallCheck.js
// module id = ./node_modules/react-phone-number-input/node_modules/babel-runtime/helpers/classCallCheck.js
// module chunks = 0 1 2